import React from 'react';
import { CheckCircle, Users, Clock, Shield } from 'lucide-react';
import FeatureCard from '../common/FeatureCard';
import { FeatureCardProps } from '../../types';

const Features: React.FC = () => {
  const features: FeatureCardProps[] = [
    {
      icon: CheckCircle,
      title: "Automated Sync",
      description: "Automatically sync your Roommaster data with Xero in real-time. No more manual data entry or double handling."
    },
    {
      icon: Shield,
      title: "Secure & Reliable",
      description: "Enterprise-grade security with encrypted data transmission and secure OAuth authentication protocols."
    },
    {
      icon: Clock,
      title: "Save Time",
      description: "Reduce accounting tasks from hours to minutes. Focus on growing your business instead of managing spreadsheets."
    },
    {
      icon: Users,
      title: "Expert Support",
      description: "Get help from our team of property management and accounting experts whenever you need it."
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our Integration?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Built by property management professionals who understand your daily challenges.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;